import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useAdminTheme } from '../../contexts/AdminThemeContext';
import PaymentList from '../payment/PaymentList';
import FinanceOperatorRegistration from '../financeOperator/FinanceOperatorRegistration';
import { Plus } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';

const PaymentRequests = () => {
  const [searchParams] = useSearchParams();
  const { isDarkMode } = useAdminTheme();
  const { user } = useAuth();
  const [showRegisterModal, setShowRegisterModal] = useState(false);

  // Extract all URL parameters as initial filters
  const initialFilters = {
    status: searchParams.get('status') || 'all',
    search: searchParams.get('search') || '',
    startDate: searchParams.get('startDate') || '',
    endDate: searchParams.get('endDate') || '',
    page: parseInt(searchParams.get('page')) || 1,
    limit: parseInt(searchParams.get('limit')) || 10
  };

  return (
    <div className={`max-w-8xl mx-auto px-4 sm:px-5 lg:px-6 py-6 transition-colors duration-300 ${
      isDarkMode ? 'bg-skyone-page-dark' : 'bg-gray-50'
    }`}>
      {/* Header with Register Finance Operator button */}
      {user?.role === 'admin' && (
        <div className="mb-6 flex justify-end">
          <button
            onClick={() => setShowRegisterModal(true)}
            className="btn btn-primary flex items-center"
          >
            <Plus className="w-5 h-5 mr-2" />
            Register Finance Operator
          </button>
        </div>
      )}

      <PaymentList initialFilters={initialFilters} />

      {/* Finance Operator Registration Modal */}
      <FinanceOperatorRegistration
        isOpen={showRegisterModal}
        onClose={() => setShowRegisterModal(false)}
        onSuccess={() => {
          setShowRegisterModal(false);
          // Optionally refresh payment list or show success message
        }}
      />
    </div>
  );
};

export default PaymentRequests;
